import {fetchGet, generateEndpoint} from "../utils/request";

export const getMedicalOrganizations = async() => {
  const url = `${generateEndpoint('getMedicalOrganizations')}`
  return fetchGet(url, null)
}
